import type * as React from 'react'
import { Button } from '@/components/ui/button'
import { cn } from '@/shared/lib/utils'

interface IconButtonProps
  extends Omit<React.ComponentProps<typeof Button>, 'children' | 'aria-label'> {
  icon: React.ReactNode
  ariaLabel?: string
}

export function IconButton({
  icon,
  onClick,
  ariaLabel,
  className,
  size = 'icon',
  variant = 'ghost',
  ...props
}: IconButtonProps) {
  return (
    <Button
      type="button"
      size={size}
      variant={variant}
      onClick={onClick}
      aria-label={ariaLabel}
      className={cn('cursor-pointer active:scale-95', className)}
      {...props}
    >
      {icon}
    </Button>
  )
}
